<template>
  <AppLoader />
</template>
<script setup lang="ts">
import { onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';
import { useUserManagerStore } from '../stores/userManagerStore'
import AppLoader from '../components/AppLoader.vue'

import axios from 'axios';
import log from '../utils/logger';
const router = useRouter()
const userManagerStore = useUserManagerStore()

const code = router.currentRoute.value.query.code as string
const state = router.currentRoute.value.query.state as string

log.debug(`[GO-DEBUG][CALLBACK] OauthCallback mounted — code=${code ? 'present' : 'MISSING'}, state=${state ? 'present' : 'MISSING'}`)
log.debug(`[GO-DEBUG][CALLBACK] Full query: ${JSON.stringify(router.currentRoute.value.query)}`)

onBeforeMount(async () => {
  try {
    log.debug(`[GO-DEBUG][CALLBACK] calling signinRedirectCallback...`)
    await userManagerStore.signinRedirectCallback(code, state)
    log.debug(`[GO-DEBUG][CALLBACK] signinRedirectCallback OK`)

    const token = await userManagerStore.getToken
    log.debug(`[GO-DEBUG][CALLBACK] token retrieved: ${token ? 'yes' : 'NONE'}`)

    axios.defaults.headers.common['Authorization'] = `Bearer ${token?.access_token}`
  } catch (e) {
    log.error(`[GO-DEBUG][CALLBACK] signinRedirectCallback FAILED:`, e)
    await userManagerStore.removeVerifiers()
    log.debug(`[GO-DEBUG][CALLBACK] re-triggering signinRedirect...`)
    userManagerStore.signinRedirect()
  }
})

</script>